import axios from "axios";
import RemoveModal from "components/ui/RemoveModal/RemoveModal";
import DynamicTable from "components/ui/TableComponents/DynamicTable";
import { useSettingContext } from "context/SettingContext";
import apiClient from "lib/api-client";
import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { useReportsList, useUpdateReportListData } from "./Api/myBinnysAccessApi";
import { findSpecificMenu, findSpecificSubMenu, isAllowed } from "utils/checkUserRigths";
import { usePermissions } from "context/PermissionsContext";

const defaultData = [
  {
    sectionTitle: "Reports (Quotes & Orders)",
  },
  {
    sectionTitle: "Reports (Transaction)",
  },
];

const DEFAULT_REPORTS_NAMES = [250, 264];

const ClientReportPage = () => {
  const { clientId } = useParams(); // if route is /users/:id

  const { data: reports = [], isLoading, isError } = useReportsList(clientId);
  const { mutate: updateReportList } = useUpdateReportListData();
  const [initialData, setInitalData] = useState([]);
  const [reportData, setReportData] = useState([]);
  const { setMyBinnysReport, setEnableSaveLimitsBtn, setSaveRightModalOpen, saveRightModalOpen } = useSettingContext();
  const location = useLocation();
  const permissions = usePermissions();

  const hasReportEditAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("My Binny's", permissions), "Report Management"), "edit");

  const handleAccessChange = (sectionTitle, index, ReportId) => {
    console.log("ReportId ===>", ReportId);
    let ignorCheck = DEFAULT_REPORTS_NAMES.includes(ReportId);
    if (ignorCheck) {
      console.log("ignorCheck ===>", ignorCheck);
      return null;
    }
    setReportData((prev) =>
      prev.map((section) =>
        section.sectionTitle === sectionTitle
          ? {
              ...section,
              data: section.data.map((item, i) => (i === index && !ignorCheck ? { ...item, access: !item.access } : item)),
            }
          : section
      )
    );
  };

  const sections = reportData?.map((section) => ({
    headers: [
      { label: "Sr no.", className: "narrow" },
      { label: section.sectionTitle, className: "default" },
      { label: "Access", className: "default" },
    ],
    rows:
      section?.data?.map((item, i) => [
        i + 1,
        item?.name,
        {
          type: "checkbox",
          checked: item?.access || DEFAULT_REPORTS_NAMES.includes(item?.ReportId),
          onChange: () => handleAccessChange(section?.sectionTitle, i, item?.ReportId),
          hide: DEFAULT_REPORTS_NAMES.includes(item?.ReportId),
        },
      ]) || [],
  }));

  // RemoveModal Info
  const btnInfo = [
    {
      btnName: "No",
      bgColor: "#E77B7B",
      click: () => {
        setSaveRightModalOpen(false);
      },
    },
    {
      btnName: "Yes",
      bgColor: "#50c878",
      click: async () => {
        let reportListData = reportData?.flatMap((res) => res?.data?.filter((item) => item?.access).map((item) => item?.ReportId)) || [];
        updateReportList({ clientId, reportListData });
        setSaveRightModalOpen(false);
        setEnableSaveLimitsBtn(false);
      },
    },
  ];

  useEffect(() => {
    if (reportData) {
      const isChanged = JSON.stringify(reportData) !== JSON.stringify(initialData);
      setEnableSaveLimitsBtn(isChanged);
    }
  }, [reportData]);

  useEffect(() => {
    setMyBinnysReport(true);
    return () => {
      setMyBinnysReport(false);
    };
  }, []);

  useEffect(() => {
    setInitalData(defaultData);
    setReportData(defaultData);
  }, []);

  useEffect(() => {
    if (reports?.length) {
      setInitalData(reports);
      setReportData(reports);
    }
  }, [reports]);

  return (
    <>
      <DynamicTable sections={sections} loading={isLoading} error={isError} hasReportEditAccess={hasReportEditAccess}/>
      <RemoveModal open={saveRightModalOpen} setOpen={setSaveRightModalOpen} btnInfo={btnInfo} heading="Do you want to save access changes?" />
    </>
  );
};

export default ClientReportPage;
